/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('purgeSelectedRevisions', ['$q', '$translate', 'NodeRevision', 'confirmAction',
        function ($q, $translate, NodeRevision, confirm) {
            return function (items) {
                return _confirm(items).then(function () {
                    return _purgeRevisions(items);
                });
            };

            function _confirm(items) {
                return confirm({}, {
                    confirmTitle: $translate.instant('purge_selected_file_revisions_dialog_header', { COUNT: items.length }, 'messageformat'),
                    confirmSubmit: $translate.instant('Delete'),
                    confirmBodyTemplate: 'modals/actions/confirm_purge_selected_file_revisions',
                    modalUpdate: function (modalScope) {
                        modalScope.revisions = items;
                    }
                });
            }

            function _purgeRevisions(items) {
                return $q.all(items.map(function (item) {
                    return NodeRevision.purge({ node_uuid: item.uuid, revision: item.revision }).$promise;
                }));
            }
        }]);
